module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "bars"
  }, [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4c1f1afe!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/volumeIndicator.vue
// module id = 1768
// module chunks = 61